const initialState = {
  loading: false,
  totalSupply: 0,
  cost: 0,
  error: false,
  paused: false,
  user_tokens: Array(),
  errorMsg: "",
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_DATA_REQUEST":
      return {
        ...state,
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_NFTS_REQUEST":
      return {
        ...state,
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        totalSupply: action.payload.totalSupply,
        cost: action.payload.cost,
        paused: action.payload.paused,
        walletOfOwner: action.payload.walletOfOwner,
        error: false,
        errorMsg: "",
      };
    case "CHECK_NFTS_SUCCESS":
      return {
        ...state,
        loading: false,
        walletOfOwner: action.payload.walletOfOwner,
        user_tokens: action.payload.user_tokens,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_FAILED":
      return {
        ...initialState,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
